import { t } from 'i18next';

import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { VisibilityActions } from './VisibilityActions';
import { GlobalHelper } from '../utils/GlobalHelper';
import { ViewSettingsActions } from './ViewSettingsActions';
import { SidebarModule } from '../constants/Enums';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { TooltipActions } from './TooltipActions';
import { TooltipIds } from '../constants/TooltipIds';
import { ArticleActions } from './ArticleActions';

import room = egr.wcf.room;

export abstract class ArchitectureActions {
    public static async showInputField(inputId: string, length: number, clickedElement: HTMLElement): Promise<number> {
        const inputValue: number | null = await new Promise<number | null>((resolve, reject) => {
            VisibilityActions.setLengthDialog({
                onSubmit: resolve,
                onCancel: reject,
                id: inputId,
                defaultValue: GlobalHelper.getLocaleLengthString(length),
                clickedElement
            });
        });

        if (inputValue == null) {
            return 0;
        }

        return inputValue;
    }

    public static drawWall(): void {
        ViewSettingsActions.changeSidebar(SidebarModule.NONE);
        const wallCount: number = GlobalHelper.getWallCount();
        if (AppConfigurationStore.getState().touchDevice) {
            VisibilityActions.showInfoMessage(t('Begin drawing wall'));
        } else {
            VisibilityActions.showInfoMessage(t('Right click or press Esc to end wall drawing operation.'));
        }
        TooltipActions.hideTooltip();

        const wallTool: room.tool.Wall = new room.tool.Wall(GlobalHelper.roomManager);
        wallTool.eventStopped.addListener(() => {
            ViewSettingsActions.setDragMode(false);
            TooltipActions.showTooltip(TooltipIds.DRAW_WALL_ICON);
            VisibilityActions.showInfoMessage('');
            ArticleActions.invalidateArticleList();
            if (wallCount !== GlobalHelper.getWallCount()) {
                AppDispatcher.dispatch({actionType: ActionConstants.SET_WALLTOOL_FLAG, value: true});
            }
        });
        GlobalHelper.coreApp.tools.startTool(wallTool);
        GlobalHelper.focusCanvas();
        ViewSettingsActions.setDragMode(true);
    }

    public static insertOpening(): void {
        GlobalHelper.roomManager.insertWallOpening('Opening');
        ArticleActions.invalidateArticleList();
    }

    public static insertDoor(): void {
        GlobalHelper.roomManager.insertWallOpening('Door');
        ArticleActions.invalidateArticleList();
    }

    public static insertWindow(): void {
        GlobalHelper.roomManager.insertWallOpening('Window');
        ArticleActions.invalidateArticleList();
    }

    public static finishRoomMode(): void {
        // Globals.roomManager.finishEditMode();
    }

    public static toggleRoomMode(): void {
        /*if (Globals.roomManager.editModeStarted) {
            Globals.roomManager.finishEditMode();
        } else {
            Globals.roomManager.startEditMode();
        }*/

        AppDispatcher.dispatch({
            actionType: ActionConstants.CHANGE_SIDEBAR,
            value: null
        });
    }

    public static startRectPolygonTool(pMode: unknown): void {
        /*Globals.roomManager.startEditMode();

        let tTool: room.tool.RectPolygon = new room.tool.RectPolygon(Globals.roomManager);
        tTool.mode = pMode;
        Globals.coreApp.tools.startTool(tTool);*/

        AppDispatcher.dispatch({
            actionType: ActionConstants.CHANGE_SIDEBAR,
            value: null
        });
    }

    public static startPolygonTool(): void {
        /*Globals.roomManager.startEditMode();

        let tTool: room.tool.Polygon = new room.tool.Polygon(Globals.roomManager);
        Globals.coreApp.tools.startTool(tTool);*/

        AppDispatcher.dispatch({
            actionType: ActionConstants.CHANGE_SIDEBAR,
            value: null
        });
    }

    public static startInsertOpeningTool(pType: unknown): void {
        /*Globals.roomManager.startEditMode();

        let tTool: room.tool.InsertStructureOpening = new room.tool.InsertStructureOpening(Globals.roomManager);
        Globals.coreApp.tools.startTool(tTool, pType);*/

        AppDispatcher.dispatch({
            actionType: ActionConstants.CHANGE_SIDEBAR,
            value: null
        });
    }

    public static toggle2d3d(): void {
        // Globals.roomManager.setShow3d(!Globals.roomManager.show3d);

        AppDispatcher.dispatch({
            actionType: ActionConstants.CHANGE_SIDEBAR,
            value: null
        });
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/ArchitectureActions.tsx